import { module as BaseModule } from 'modujs'
import { load } from 'recaptcha-v3'
import { i18 } from '../utils/dom'

export default class extends BaseModule {
  init() {
    this.options = this.el.querySelectorAll('[data-form-contact-option]')
    this.chooseOptions = this.el.querySelector('[data-form-contact-option-choose]')
    this.form = this.el.querySelector('[data-form-contact]')
    this.typeInput = this.el.querySelector('#type')
    this.submit = this.el.querySelector('[data-form-submit]')
    this.inputs = this.el.querySelectorAll('input, textarea')
    this.notice = this.el.querySelector('[data-form-contact-notice]')
    this.noticeMessage = this.el.querySelector('[data-form-contact-notice-message]')
    this.success = document.querySelector('[data-contact-form-success]')
    this.isSending = false
    this.isSent = false

    this.options.forEach((option, index) => {
      option.addEventListener('click', (e) => {
        e.preventDefault()

        e.target.closest('form').dataset.labels = index

        this.typeInput.value = option.innerHTML.trim()
        this.form.classList.remove('hidden')
        this.chooseOptions.classList.add('hidden')

        this.options.forEach((opt, i) => {
          if (i === index) {
            opt.setAttribute('aria-selected', 'true')
          } else {
            opt.removeAttribute('aria-selected')
          }
        })
      })
    })

    this.inputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.checkInputs()
      })
    })

    this.el.addEventListener('submit', async (e) => {
      e.preventDefault()
      if (this.isSending || this.isSent) return
      this.verify()
    })
  }

  checkInputs() {
    let isValid = true

    this.inputs.forEach((input) => {
      if (input.tagName === 'TEXTAREA' && input.value === '') {
        isValid = false
      }

      const type = input.getAttribute('type')
      if ((type === 'hidden' || type === 'text' || type === 'email') && input.value === '') {
        isValid = false
      }
      if (type === 'checkbox' && !input.checked) {
        isValid = false
      }

      if (type === 'file' && input.files.length === 0) {
        isValid = false
      }

      // additonal check for file, max 5MB  per file
      if (type === 'file' && input.files.length > 0) {
        const file = input.files[0]
        if (file.size > 5 * 1024 * 1024) {
          isValid = false

          this.notice.classList.remove('hidden')
          this.noticeMessage.innerHTML = i18(
            'Le fichier ne doit pas dépasser 5MB',
            'The file must not exceed 5MB',
            'Het bestand mag niet groter zijn dan 5MB',
          )
        }
      }
    })

    if (isValid) {
      this.submit.removeAttribute('disabled')
    }
  }

  async verify() {
    this.send()
    /*
    this.isSending = false
    const recaptcha = await load('6Leh7jQpAAAAALqFQEOfIz3nZrPKbUBrq0BIx28N')
    const token = await recaptcha.execute('form')

    try {
      const request = await fetch('/wp-json/custom/v1/recaptcha', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token,
        }),
      })

      const response = await request.json()
      const { status } = request
      const { message } = response

      if (status === 200) {
        this.notice.classList.add('hidden')
        this.send()
        return
      }

      this.notice.classList.remove('hidden')
      this.notice.innerHTML = message
      this.submit.innerHTML = 'Envoyer'
      this.isSending = false
    } catch (error) {
      console.error(error)
      return false
    }
    */
  }

  async send() {
    this.isSending = true
    const formData = new FormData(this.el)

    const data = {}
    const formDataArray = Array.from(formData)
    formDataArray.forEach(([key, value]) => {
      data[key] = value
    })

    this.submit.innerHTML = i18('Envoi en cours..', 'Sending..', 'Senden..')

    const { formAction } = this.el.dataset
    const headers = formAction === 'contact-form' ? { 'Content-Type': 'application/json' } : {}

    const request = await fetch(`/wp-json/custom/v1/${formAction}`, {
      method: 'POST',
      headers,
      body: formAction === 'contact-form' ? JSON.stringify(data) : formData,
    })

    const response = await request.json()
    const { status } = request
    const { message } = response

    if (status === 200) {
      this.submit.innerHTML = i18('Envoyer', 'Send', 'Senden');
      this.success.classList.remove('hidden');
      this.el.classList.add('hidden');
      
      // Scroll to the top of the page
      window.scrollTo({
          top: 0,
          behavior: 'smooth' // Smooth animation
      });
  
      this.isSent = true;
    } else {
      this.notice.classList.remove('hidden');
      this.noticeMessage.innerHTML = message;
  
      this.submit.innerHTML = i18('Envoyer', 'Send', 'Senden');
      this.isSending = false;
    }
  }
}
